import { render, staticRenderFns } from "./AM_Tac.vue?vue&type=template&id=0c7ea16d&scoped=true&"
import script from "./AM_Tac.vue?vue&type=script&lang=js&"
export * from "./AM_Tac.vue?vue&type=script&lang=js&"
import style0 from "./AM_Tac.vue?vue&type=style&index=0&id=0c7ea16d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ea16d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
